// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentHeader_wrapper__DorZ9","title":"ContentHeader_title__K9chA","description":"ContentHeader_description__SmXcc","buttonGoHome":"ContentHeader_buttonGoHome__XqoAv"};